import React from "react";
import { Row, Col } from "reactstrap";

import ServerStatistic from "../dashboardEA/components/ServerStatistic";
import BitbucketStatistics from "./components/BitbucketStatistics";
import Deployment from "./components/Deployment";
import JiraStatistics from "./components/JiraStatistics";
import JiraWeb from "./components/JiraWeb";
import JiraTablet from "./components/JiraTablet";
import Widget from "../../components/Widget";

import style from "./ProjectManagement.module.scss";
import "../widgets/Widgets.scss";

const Dashboard = () => {
  return (
    <div className={style.root}>
      <Row className="mt-4">
        <Col xl={4} lg={6} md={6} xs={12} className="colCustom40">
          <Row>
            <Col xs={12}>
            <Widget className="hotFix">
                <div className="clearfix height150 flexCenter">
                  <img src="https://www.emiratesauction.com/assets/NewHeaderRevamp2Icons/logo.svg" />
                </div>
              </Widget>
            </Col>
          </Row>
          <Row>
            <Col xl={6} lg={6} md={6} xs={12}>
              <Deployment />
            </Col>
            <Col xl={6} lg={6} md={6} xs={12}>
              <ServerStatistic />
            </Col>
          </Row>
          <Row>
          <Col xl={6} lg={6} md={6} xs={12}>
              <JiraWeb />
            </Col>
            <Col xl={6} lg={6} md={6} xs={12}>
              <JiraTablet />
            </Col>
          </Row>
        </Col>
        <Col xl={8} lg={6} md={6} xs={12} className="colCustom80">
          <Row>
            <BitbucketStatistics />
          </Row>

        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
